import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';

const Heading = props => {
    return (
        <header className={classNames({
            'page-header': true,
            'page-header--breadcrumb': props.breadcrumb,
            ...props.modifiers
        })}>
            <div className="page-header__content">
                {props.breadcrumb &&
                    <section className="breadcrumb breadcrumb--min-padding">
                        <Link className="breadcrumb__item" title={props.breadcrumb} to={props.breadcrumbUrl}>{props.breadcrumb}</Link>
                    </section>
                }

                {props.heading &&
                    <h1 className="page-header__heading"><span>{props.heading}</span></h1>
                }
                
                {props.subheading &&
                    <p className="page-header__subheading"><span>{props.subheading}</span></p>
                }
            </div>
            {props.children}
        </header>
    );
};

export default Heading;